import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useUpdateSwapMutation } from "../../redux/swapApi";

import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

function EditSwap({ show, onHide, swap }) {
    const { t } = useTranslation();
    const [editData, setEditData] = useState({});
    const [updateSwap] = useUpdateSwapMutation();

    useEffect(() => {
        if (swap) {
            setEditData(swap);
        }
    }, [swap]);

    const handleEditSave = async () => {
        try {
            const response = await updateSwap(editData).unwrap();
            if (response.status) {
                toast.success(response.message || "Swap updated successfully!");
                onHide();
            } else {
                toast.error(response.message || "Failed to update swap");
            }
        } catch (error) {
            toast.error("Error updating swap");
            console.error("Error updating swap:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_swap')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('swap_rate')}</Form.Label>
                        <Form.Control
                            type="text"
                            value={editData.swap_rate || ""}
                            onChange={(e) => setEditData({ ...editData, swap_rate: e.target.value })}
                        />
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                    {t('save_changes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditSwap;
